var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberCircleEight = function SvgIconNumberCircleEight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.318 7.008a3.05 3.05 0 0 1 3.852.386l.005.005a3.1 3.1 0 0 1 .887 2.162v.007a3.05 3.05 0 0 1-.703 1.932l-.028.033.1.097a3.429 3.429 0 1 1-4.743-.097 3.052 3.052 0 0 1 .63-4.525m1.796 1.495a1.053 1.053 0 1 0 .948 1.057 1.1 1.1 0 0 0-.31-.756 1.05 1.05 0 0 0-.638-.301m-.898 4.365a1.429 1.429 0 1 1 1.587 2.376 1.429 1.429 0 0 1-1.587-2.376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
  }))));
};
export default SvgIconNumberCircleEight;